import { useState, useEffect } from 'react';
import { Button, Alert, AlertTitle, AlertDescription } from '@predoc/cow';
import { signIn } from 'aws-amplify/auth';
import { useMfa } from '../MfaContext';
import { useCountdown } from '@/hooks';
import { toast } from 'sonner';
import { Send } from 'lucide-react';

export const ResendMFA = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { tempCredentials } = useMfa();
  const { countdown, isActive, start, reset } = useCountdown({ duration: 60 });

  // Reset countdown when component unmounts (user navigates away)
  useEffect(() => {
    return () => reset();
  }, [reset]);

  const handleResend = async () => {
    if (isActive) {
      toast.error('Please wait 60 seconds before resending.');
      return;
    }

    if (!tempCredentials) {
      toast.error('Session expired, please re-login.');
      return;
    }

    try {
      setIsLoading(true);
      const result = await signIn({
        username: tempCredentials.username,
        password: tempCredentials.password,
      });

      if (
        result.isSignedIn ||
        result.nextStep.signInStep === 'CONFIRM_SIGN_IN_WITH_SMS_CODE'
      ) {
        start();
      }
    } catch {
      toast.error('Failed to resend verification code. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  if (isActive) {
    return (
      <Alert variant="accent" className="mt-8">
        <Send className="h-5 w-5" />
        <AlertTitle>Verification Code Sent</AlertTitle>
        <AlertDescription>
          You can send another code in {countdown} seconds.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Button
      type="button"
      variant="link"
      onClick={handleResend}
      disabled={isLoading}
      className="mt-8"
    >
      Resend Verification Code
    </Button>
  );
};
